import { CourseType } from 'common-proptypes'
import { Link } from 'react-router-dom'
import ProductName from 'components/ProductName'

import styles from './CourseRenderer.module.scss'

export default class CourseRenderer extends React.PureComponent {
  static propTypes = {
    course: CourseType.isRequired,
  }

  render() {
    const {
      className,
      course,
      ...passedProps
    } = this.props
    const {
      name,
      description,
      id,
    } = course
    /* eslint-disable react/no-danger */
    return (
      <div {...passedProps} className={cx(styles.root, 'course', className)}>
        <div className={cx(styles.body)}>
          <span aria-label="course name">
            <Link to={`/${id}`} className="course-title"><ProductName name={name} block /></Link>
          </span>
          {description && (
            <p className="course-description" dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </div>
        <div className={cx(styles.action)}>
          <Link to={`/${id}`} className="button">Details</Link>
        </div>
      </div>
    )
  }
}
